import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import CreateUser from '../components/CreateUser.vue'
import Labelling from '../components/Labelling.vue'
import QuestionLabelling from '../components/QuestionLabelling.vue'
import GraphSelector from '../components/GraphSelector.vue'
import End from '../components/End.vue'
import Instruction from '../components/Instruction.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path:'/create_user',
    name:"Create New User",
    component:CreateUser
  },
  {
    path:'/labelling/:userid/:username/:graphid',
    name:"Labelling",
    component:Labelling,
  },
  {
    path:'/question-labelling/:userid/:username/:graphid',
    name:"QuestionLabelling",
    component:QuestionLabelling,
  },
  {
    path:'/graph-selector/:userid/:username',
    name:"GraphSelector",
    component:GraphSelector,
  },
  {
    path:'/end/:userid',
    name:"End",
    component:End,
  },
  {
    path:'/instruction/',
    name:"Instruction",
    component:Instruction,
  }
]

const router = new VueRouter({
  routes
})

export default router
